export const FETCH_USER_PAYMENT_HISTORY = 'FETCH_USER_PAYMENT_HISTORY'
export const USER_PAYMENT_HISTORY_SUCCESS = 'USER_PAYMENT_HISTORY_SUCCESS'
export const USER_PAYMENT_HISTORY_FAILURE = 'USER_PAYMENT_HISTORY_FAILURE'
export const FETCH_USER_PAYMENT_RECEIPT = 'FETCH_USER_PAYMENT_RECEIPT'
